export default function mobileDrawer(id, text) {
    $('.mobile-drawer').remove()
    const drawer = $(`
<div id="${id}" class="mobile-drawer" style="display: none">
        <button type="button" class="close" aria-label="${translate.close_btn}"><span><svg viewBox="0 0 27 27"><title>${translate.close_btn}</title><use xlink:href="#icon-close-small"></use></svg></span></button>
        ${text}
</div>`)


    drawer.appendTo('body')
    const globalListener = e => {
        if (!drawer[0].contains(e.target)) drawer.remove()
    };
    setTimeout(() => window.addEventListener('click', globalListener), 0);
    drawer.on('removed', e => removeEventListener('click', globalListener))
    drawer.find('button.close').on('click', function () {
        $(this).closest('#' + id).remove();
    })
    drawer.slideDown()
    return drawer
}
